module.exports = __webpack_public_path__ + "static/media/menu-button.96f8df81.jpg";